import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function NoActivePlanCard() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
          <div className="space-y-1">
            <CardTitle>{t('customer.planManagement.currentSubscription.title')}</CardTitle>
            <CardDescription>{t('customer.planManagement.currentSubscription.description')}</CardDescription>
          </div>
          <Badge variant="outline">{t('customer.planManagement.currentSubscription.noPlan')}</Badge>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-lg font-semibold">{t('customer.planManagement.currentSubscription.noPlan')}</p>
      </CardContent>
    </Card>
  );
}

